import { render, staticRenderFns } from "./TaggedPhoto.vue?vue&type=template&id=f5e30754&scoped=true"
import script from "./TaggedPhoto.vue?vue&type=script&lang=js"
export * from "./TaggedPhoto.vue?vue&type=script&lang=js"
import style0 from "./TaggedPhoto.vue?vue&type=style&index=0&id=f5e30754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e30754",
  null
  
)

export default component.exports